import * as React from "react";
const ProgressBar = ({ bgcolor, completed }) => {
    const containerStyles = {
        height: 20,
        width: '100%',
        backgroundColor: "#e0e0de",
        borderRadius: 50,
        marginTop: 50,
        marginBottom: 50,
    };
    const fillerStyles = {
        height: '100%',
        width: `${completed}%`,
        backgroundColor: bgcolor,
        transition: 'width 1s ease-in-out',
        borderRadius: 'inherit',
        //textAlign: 'right',
    };
    const labelStyles = {
        padding: 5,
        color: 'white',
        fontWeight: 'bold',
    };
    return (React.createElement("div", { style: containerStyles },
        React.createElement("div", { style: fillerStyles },
            React.createElement("span", { style: labelStyles }, `${completed}%`))));
};
export default ProgressBar;
